export enum ECallbackWidgetPlacement {
  Sidebar = 'sidebar',
  Gallery = 'gallery',
  Tour = 'tour',
  Author = 'author',
}
